export enum ReqStatus {
    // Pending actions
    PendingApprovalByLine = 1, // Pending action by Line Approver

    // Approved statuses
    ApprovedByLine = 10, // Approved by Line Approver
    ApprovedByFa = 12, // Approved by Finance Analyst
    ApprovedByJv = 14, // Approved by Joint Venture Analyst
    ApprovedByPsc = 16, // Approved by PSC Analyst
    ApprovedByGas = 18, // Approved by GAS Analyst
    ApprovedByInterco = 20, // Approved by Interco Analyst
    ApprovedByAlloc = 22, // Approved by Allocations Analyst
    ApprovedByFixAss = 24, // Approved by Fixed Assets Analyst
    ApprovedByProd = 26, // Approved by Production Accounting Analyst
    ApprovedByComp = 28, // Approved by JDE Analyst

    // Pending approvals
    PendingApprovalByFa = 11, // Pending Finance Analyst Approval
    PendingApprovalByJv = 13, // Pending Joint Venture Approval
    PendingApprovalByPsc = 15, // Pending PSC Approval
    PendingApprovalByGas = 17, // Pending GAS Approval
    PendingApprovalByInterco = 19, // Pending Interco Approval
    PendingApprovalByAlloc = 21, // Pending Allocations Approval
    PendingApprovalByFixAss = 23, // Pending Fixed Assets Approval
    PendingApprovalByProd = 25, // Pending Production Accounting Approval
    PendingApprovalByComp = 27, // Pending JDE Approval

    // Disapproved statuses
    DisapprovedByLine = -10, // Disapproved by Line Approver
    DisapprovedByFa = -12, // Disapproved by Finance Analyst
    DisapprovedByJv = -14, // Disapproved by Joint Venture Analyst
    DisapprovedByPsc = -16, // Disapproved by PSC Analyst
    DisapprovedByGas = -18, // Disapproved by GAS Analyst
    DisapprovedByInterco = -20, // Disapproved by Interco Analyst
    DisapprovedByAlloc = -22, // Disapproved by Allocations Analyst
    DisapprovedByFixAss = -24, // Disapproved by Fixed Assets Analyst
    DisapprovedByProd = -26, // Disapproved by Production Accounting Analyst
    DisapprovedByComp = -28, // Disapproved by JDE Analyst

    // Final statuses
    PendingFinalReview = 99, // Pending Final review
    Completed = 100, // Completed and Closed
    Returned = 0, // Returned
    Cancelled = -100, // Cancelled
}

/**
 * A mapping of ReqStatus values to user-friendly descriptions for UI display.
 */
export const ReqStatusDescriptions: { [key in ReqStatus]: string } = {
    [ReqStatus.PendingApprovalByLine]: "Pending approval by Line Approver",
    [ReqStatus.ApprovedByLine]: "Approved by Line Approver",
    [ReqStatus.ApprovedByFa]: "Approved by Finance Analyst",
    [ReqStatus.ApprovedByJv]: "Approved by Joint Venture Analyst",
    [ReqStatus.ApprovedByPsc]: "Approved by PSC Analyst",
    [ReqStatus.ApprovedByGas]: "Approved by GAS Analyst",
    [ReqStatus.ApprovedByInterco]: "Approved by Interco Analyst",
    [ReqStatus.ApprovedByAlloc]: "Approved by Allocations Analyst",
    [ReqStatus.ApprovedByFixAss]: "Approved by Fixed Assets Analyst",
    [ReqStatus.ApprovedByProd]: "Approved by Production Accounting Analyst",
    [ReqStatus.ApprovedByComp]: "Approved by JDE Analyst",
    [ReqStatus.PendingApprovalByFa]: "Pending approval by Finance Analyst",
    [ReqStatus.PendingApprovalByJv]: "Pending approval by Joint Venture Analyst",
    [ReqStatus.PendingApprovalByPsc]: "Pending approval by PSC Analyst",
    [ReqStatus.PendingApprovalByGas]: "Pending approval by GAS Analyst",
    [ReqStatus.PendingApprovalByInterco]: "Pending approval by Interco Analyst",
    [ReqStatus.PendingApprovalByAlloc]: "Pending approval by Allocations Analyst",
    [ReqStatus.PendingApprovalByFixAss]: "Pending approval by Fixed Assets Analyst",
    [ReqStatus.PendingApprovalByProd]: "Pending approval by Production Accounting Analyst",
    [ReqStatus.PendingApprovalByComp]: "Pending approval by JDE Analyst",
    [ReqStatus.DisapprovedByLine]: "Disapproved by Line Approver",
    [ReqStatus.DisapprovedByFa]: "Disapproved by Finance Analyst",
    [ReqStatus.DisapprovedByJv]: "Disapproved by Joint Venture Analyst",
    [ReqStatus.DisapprovedByPsc]: "Disapproved by PSC Analyst",
    [ReqStatus.DisapprovedByGas]: "Disapproved by GAS Analyst",
    [ReqStatus.DisapprovedByInterco]: "Disapproved by Interco Analyst",
    [ReqStatus.DisapprovedByAlloc]: "Disapproved by Allocations Analyst",
    [ReqStatus.DisapprovedByFixAss]: "Disapproved by Fixed Assets Analyst",
    [ReqStatus.DisapprovedByProd]: "Disapproved by Production Accounting Analyst",
    [ReqStatus.DisapprovedByComp]: "Disapproved by JDE Analyst",
    [ReqStatus.PendingFinalReview]: "Pending final review",
    [ReqStatus.Completed]: "Completed and closed",
    [ReqStatus.Returned]: "Returned for further action",
    [ReqStatus.Cancelled]: "Cancelled",
};